/* eslint-disable default-case */
import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import TextField from 'forms/shared/fields/text'
import SelectField from 'forms/shared/fields/select'
import MultiSelect from 'forms/shared/fields/filter-select-multi'
import { Field, formValueSelector } from 'redux-form'
import TextArea from 'forms/shared/fields/text-area'
import LocationSelectorField from 'forms/shared/fields/location-selector-field'
import MapSearchBox from 'components/shared/form/map-search-box'
import countryActions from 'actions/countries/actions'
import areaActions from 'actions/areas/actions'
import landmarkActions from 'actions/landmarks/actions'
import {
  FORM_ERROR_CLASS,
  INPUT_ERROR_CLASS,
  MERCHANT_FORM_LABEL,
  MERCHANT_INPUT_CLASS,
  REACT_SELECT_CUSTOM_STYLE_MERCHANT,
} from 'constants/css-style'

const DetailFields = ({
  countries,
  areasPerCity,
  fetchCountries,
  action,
  latLng,
  fetchAreasPerCity,
  fetchLandmarkPerArea,
  landmarks,
  fetchCountryCities,
  cities,
  venueDetails,
}) => {
  useEffect(() => {
    fetchCountries()
  }, [])

  useEffect(() => {
    const keyLength = Object.keys(venueDetails).length
    if (keyLength || (!keyLength && action === 'add')) {
      if (venueDetails.place_id && !areasPerCity.length) fetchAreasPerCity(venueDetails.place_id)
      if (venueDetails.area_id && !landmarks.length) fetchLandmarkPerArea(venueDetails.area_id)
      if (venueDetails.country_id && !cities.length) fetchCountryCities(venueDetails.country_id)
    }
  }, [venueDetails])

  const handleSelectChange = (key, value) => {
    switch (key) {
      case 'place_id': {
        fetchAreasPerCity(value)
        break
      }
      case 'area_id': {
        fetchLandmarkPerArea(value)
        break
      }
      case 'country_id': {
        fetchCountryCities(value)
        break
      }
    }
  }

  const handleDropdownValues = (key) => {
    switch (key) {
      case 'country': {
        const values = countries.map((c) => {
          const country = {
            label: c.label,
            value: c.id,
          }
          return country
        })
        return values
      }
      case 'city': {
        const values = cities.map((city) => {
          const value = {
            label: city.name,
            value: city.id,
          }
          return value
        })
        return values
      }
      case 'area': {
        const values = areasPerCity.map((area) => {
          const value = {
            label: area.name,
            value: area.id,
          }
          return value
        })
        return values
      }
      case 'landmarks': {
        const values = landmarks.map((landmark) => {
          const value = {
            label: landmark.title,
            value: landmark.id,
          }
          return value
        })
        return values
      }
    }
  }

  return (
    <div className="details py-6">
      <p className="font-bold text-xl mb-3">Venue Details</p>
      <div className="flex flex-wrap">
        <div className="w-1/2">
          <div className="w-11/12">
            <Field
              type={'text'}
              name={'name'}
              label={'Venue Name'}
              groupClassName="my-3 w-full"
              count={60}
              placeholder={'Type in venue name'}
              labelClassName={MERCHANT_FORM_LABEL}
              inputClassName={MERCHANT_INPUT_CLASS}
              inputErrorClassName={INPUT_ERROR_CLASS}
              errorClassName={FORM_ERROR_CLASS}
              component={TextField}
            />
            <Field
              name="country_id"
              label={'Country'}
              labelClassName={MERCHANT_FORM_LABEL}
              groupClassName="my-3 w-full"
              placeholder="Select a country..."
              options={handleDropdownValues('country')}
              handleChange={(value) => handleSelectChange('country_id', value)}
              inputErrorClassName={INPUT_ERROR_CLASS}
              errorClassName={FORM_ERROR_CLASS}
              component={SelectField}
            />
          </div>
        </div>
        <div className="w-1/2 flex flex-row-reverse">
          <div className="w-11/12">
            <Field
              type={'text'}
              name={'description'}
              placeholder={
                'This field will be completed by the FlySpaces Team. For any concerns, reach out to a Space Expert'
              }
              label={'Venue Description'}
              groupClassName="my-3"
              rows={5}
              count={160}
              labelClassName={MERCHANT_FORM_LABEL}
              inputClassName={'border w-full rounded text-xs p-2'}
              inputErrorClassName={INPUT_ERROR_CLASS}
              errorClassName={FORM_ERROR_CLASS}
              component={TextArea}
            />
          </div>
        </div>
        <div className="w-1/2">
          <div className="w-11/12">
            <Field
              name="place_id"
              label={'City'}
              labelClassName={MERCHANT_FORM_LABEL}
              groupClassName="my-3 w-full"
              placeholder="Select a city..."
              options={handleDropdownValues('city')}
              handleChange={(value) => handleSelectChange('place_id', value)}
              inputErrorClassName={INPUT_ERROR_CLASS}
              errorClassName={FORM_ERROR_CLASS}
              component={SelectField}
            />
          </div>
        </div>
        <div className="w-1/2 flex flex-row-reverse">
          <div className="w-11/12 flex">
            <Field
              name="landmarks"
              label={'Landmarks'}
              labelClassName={MERCHANT_FORM_LABEL}
              groupClassName="my-3 w-full"
              options={handleDropdownValues('landmarks')}
              limit={5}
              selectStyles={REACT_SELECT_CUSTOM_STYLE_MERCHANT}
              limitLabel="Max limit landmarks"
              inputClassName={'select text-xs'}
              placeholder={'Typy or Select landmarks...'}
              inputErrorClassName={INPUT_ERROR_CLASS}
              errorClassName={FORM_ERROR_CLASS}
              component={MultiSelect}
            />
          </div>
        </div>
        <div className="w-1/2">
          <div className="w-11/12">
            <Field
              name="area_id"
              label={'Area'}
              labelClassName={MERCHANT_FORM_LABEL}
              groupClassName="my-3 w-full"
              placeholder="Select an area..."
              options={handleDropdownValues('area')}
              handleChange={(value) => handleSelectChange('area_id', value)}
              inputErrorClassName={INPUT_ERROR_CLASS}
              errorClassName={FORM_ERROR_CLASS}
              component={SelectField}
            />
          </div>
        </div>
        <div className="w-1/2 flex flex-row-reverse">
          <div className="w-11/12 flex items-end">
            <div className="w-3/12">
              <Field
                type={'text'}
                name={'floor'}
                label={'Flr No.'}
                groupClassName="my-3 w-full"
                placeholder={'Flr No.'}
                labelClassName={MERCHANT_FORM_LABEL}
                inputClassName={MERCHANT_INPUT_CLASS}
                inputErrorClassName={INPUT_ERROR_CLASS}
                errorClassName={FORM_ERROR_CLASS}
                component={TextField}
              />
            </div>
            <div className="w-1/12"></div>
            <div className="w-8/12">
              <Field
                type={'text'}
                name={'latLng'}
                label={'Address'}
                customLabelClass={MERCHANT_FORM_LABEL}
                placeholder="Building, Street Name"
                defaultValue={latLng.address}
                inputClass={MERCHANT_INPUT_CLASS}
                inputErrorClassName={INPUT_ERROR_CLASS}
                errorClassName={FORM_ERROR_CLASS}
                component={MapSearchBox}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="relative h-64 mb-10">
        <Field name="latLng" component={LocationSelectorField} />
      </div>
    </div>
  )
}

DetailFields.propTypes = {
  handleFormData: PropTypes.func,
  fetchCountries: PropTypes.func,
  countries: PropTypes.array,
  areasPerCity: PropTypes.array,
  fetchLandmarkPerArea: PropTypes.func,
  fetchAreasPerCity: PropTypes.func,
  landmarks: PropTypes.array,
  fetchCountryCities: PropTypes.func,
  cities: PropTypes.array,
  venueDetails: PropTypes.object,
  action: PropTypes.string,
  latLng: PropTypes.object,
  venueTypes: PropTypes.array,
}

const mapStateToProps = ({ countries, areas, landmarks, venue, ...state }, { form }) => {
  const selector = formValueSelector(form)
  return {
    countries: countries.list,
    areasPerCity: areas.listPerCity || [],
    landmarks: landmarks.areaLandmarks,
    latLng: selector(state, 'latLng') || {},
    cities: countries.cityPerCountry.list,
    venueDetails: venue.details,
  }
}

const mapDispatchToProps = {
  fetchAreasPerCity: areaActions.fetchAreasPerCity,
  fetchLandmarkPerArea: landmarkActions.fetchLandmarkPerArea,
  fetchCountries: countryActions.fetchCountries,
  fetchCountryCities: countryActions.fetchCountryCities,
}

export default connect(mapStateToProps, mapDispatchToProps)(DetailFields)
